import React, { memo } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import styles from './styles.module.scss';

const Index = memo((props) => {

  const dispatch = useDispatch();
  const { handleNewsDetail } = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const localesReducer = useSelector(({localesReducer}) => localesReducer.i18n);
  const { value: scrollNumReducer, cshVal } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  // 样式判断
  const normal = () => {
    if(recReSizeReducer > 1920){
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      return styles.normalSm;
    }
  };

  const { title } = props.config;

  const handleShow = () => {
    props.config.handleEvent();
  }

  return (
      <div className={normal()} onClick={handleShow}>
        <span className="ptTitle">{title}</span>
        <svg
            className="ptRectangle"
            width="23"
            height="16"
            viewBox="0 0 23 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="1.5" y="2" width="19.5" height="12" rx="6" stroke="white" strokeWidth="3" />
        </svg>
      </div>
  );
});
export default Index;
